import { render, staticRenderFns } from "./page-side-bar.html?vue&type=template&id=12193260&"
import script from "./page-side-bar.ts?vue&type=script&lang=ts&"
export * from "./page-side-bar.ts?vue&type=script&lang=ts&"
import style0 from "./page-side-bar.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports